import MuiSpeedDial, { type SpeedDialProps } from "@mui/material/SpeedDial";
import MuiSpeedDialAction, {
  type SpeedDialActionProps,
} from "@mui/material/SpeedDialAction";
import MuiSpeedDialIcon, {
  type SpeedDialIconProps,
} from "@mui/material/SpeedDialIcon";

export type { SpeedDialProps, SpeedDialActionProps, SpeedDialIconProps };

export function SpeedDial(props: SpeedDialProps) {
  return <MuiSpeedDial {...props} />;
}

export function SpeedDialAction(props: SpeedDialActionProps) {
  return <MuiSpeedDialAction {...props} />;
}

export function SpeedDialIcon(props: SpeedDialIconProps) {
  return <MuiSpeedDialIcon {...props} />;
}
